import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class FaqService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    console.log("obj", obj);

    if (obj) {
      variables = {
        first: obj.paginationData.pageSize || 10,
        after:
          obj.paginationData.after === undefined
            ? null
            : obj.paginationData.after.endCursor,
        searchParam: obj.searchParam || null,
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetFaqs($first: Int, $after: String, $searchParam: String) {
          faqs(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                title
                slug
                body
                priority
                published
                tags {
                  id
                  name
                  slug
                }
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables, // Correctly pass the variables
      errorPolicy: "all", // Optional error handling
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
        {
          faq(id: "${id}") {
            id
            title
            slug
            body
            notes
            priority
            published
            tags {
              id
              name
              slug
            }
          }
        }
      `,
    }).valueChanges;
  }

  create(obj) {
    // obj.slug = ' ';
    return this.apollo.mutate({
      mutation: gql`
        mutation createFAQ(
          $title: String!
          $slug: String!
          $body: String
          $notes: String
          $priority: Int
          $published: Boolean
        ) {
          createFAQ(
            faq: {
              title: $title
              slug: $slug
              body: $body
              notes: $notes
              priority: $priority
              published: $published
            }
          ) {
            id
          }
        }
      `,
      variables: {
        title: obj.title,
        slug: obj.slug,
        body: obj.body,
        notes: obj.notes,
        priority: obj.priority,
        published: obj.published,
      },
    });
  }

  update(obj) {
    const tags = [];
    if (obj.tags) {
      obj.tags.forEach((tag) => tags.push({ id: tag.id }));
    }
    return this.apollo.mutate({
      mutation: gql`
        mutation updateFAQ(
          $id: String!
          $title: String!
          $slug: String!
          $body: String
          $notes: String
          $priority: Int
          $published: Boolean
          $tags: [TagInput]
        ) {
          updateFAQ(
            faq: {
              id: $id
              title: $title
              slug: $slug
              body: $body
              notes: $notes
              priority: $priority
              published: $published
              tags: $tags
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        title: obj.title,
        slug: obj.slug,
        body: obj.body,
        notes: obj.notes,
        priority: obj.priority,
        published: obj.published,
        tags: tags,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeFAQ {
          removeFAQ(faq: {id: "${obj.id}"}) {
            success
          }
        }
      `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/faq.service.ts